import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { Media } from '../../../types/Media';
import Api from '../../api/api';

export type AnnouncementCreateDTO = {
  title: string;
  media: Media;
};

export const createAnnouncement = async (params: AnnouncementCreateDTO) => {
  const [response, bodyOrError] = await Api.post('announcement', params);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useCreateAnnouncement = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation('createAnnouncement', createAnnouncement, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['getAnnouncementsByPage']);
      setAlertSnackbar({
        message: `${data.title} created successfully.`,
        severity: 'success',
        vertical: 'top',
      });
      navigate('/cms/announcements');
    },
  });
};
